<template>
  <v-app style="background: #fff">
    <v-navigation-drawer
      fixed
      :clipped="clipped"
      app
      v-model="drawer"
      v-if="
        loggedInUser &&
        ['Quiz'].indexOf($route.name) === -1 &&
        !currentRoutePublic
      "
    >
      <v-card color="primary" height="196px">
        <v-layout justify-start wrap column>
          <v-flex offset-xs1>
            <v-avatar size="128" class="pt-5">
              <v-img v-bind:src="loggedInUser.avatar"></v-img>
            </v-avatar>
            <v-card-title class="white--text headline" primary-title>{{
              (loggedInUser && loggedInUser.name) || "UserError"
            }}</v-card-title>
            <!-- TODO: Find a way to add level text in this card -->
          </v-flex>
        </v-layout>
      </v-card>
      <v-list>
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :key="i"
          :to="item.path"
          exact
          :ripple="true"
          @click="toggle_check(i)"
        >
          <v-list-tile-action>
            <v-icon light v-html="item.icon" color="secondary"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              color="secondary"
              v-text="item.title"
            ></v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-icon v-if="!item.check" color="grey">forward</v-icon>
            <v-icon v-if="item.check" color="yellow darken-2">forward</v-icon>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile value="true" @click="dialog = true">
          <v-list-tile-action>
            <v-icon color="secondary">power_settings_new</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title color="secondary">Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="headline"
            >Are you sure you want to log out?</v-card-title
          >

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="signOut" color="primary">Logout</v-btn>

            <v-btn color="secondary" @click="dialog = false">Back</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-spacer pa-5></v-spacer>
      <v-divider></v-divider>
    </v-navigation-drawer>
    <v-toolbar fixed app :clipped-left="clipped" color="primary"  v-if="!currentRoutePublic">
      <v-toolbar-side-icon
        class="hidden-lg-and-up"
        v-if="loggedInUser && ['Quiz'].indexOf($route.name) === -1"
        @click="toggleDrawer"
        light
        color="white"
      ></v-toolbar-side-icon>
      <v-btn
        v-if="loggedInUser && !(['Quiz'].indexOf($route.name) === -1)"
        icon
        @click="quiz_dialog = true"
      >
        <v-icon large color="white">arrow_back</v-icon>
      </v-btn>
      <!-- <v-toolbar-title v-text="title" class="white--text"> </v-toolbar-title> -->
      <div style="margin: 0px 10px">
        <v-img class="mr-5" id="leamhIcon" :src="leamhIcon"></v-img>
      </div>
      <v-chip x-small color="white">Beta</v-chip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-dialog v-model="quiz_dialog" max-width="290">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to exit?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn to="/" color="secondary" @click="quiz_dialog = false"
            >Exit</v-btn
          >

          <v-btn color="secondary" @click="quiz_dialog = false">Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-content>
      <router-view></router-view>
    </v-content>
    <link
      type="text/css"
      rel="stylesheet"
      href="https://cdn.firebase.com/libs/firebaseui/3.1.1/firebaseui.css"
    />
  </v-app>
</template>

<script>
import Vue from "vue";
import { db, auth } from "./firebase";
import { store } from "./store/store.js";
import { menuItems } from "./constants.js";
export default {
  data() {
    return {
      cordova: Vue.cordova,
      clipped: false,
      test: true,
      items: menuItems,
      miniVariant: false,
      title: "Léamh",
      user: false,
      dialog: false,
      quiz_dialog: false,
      mobileDrawer: false,
      leamhIcon: require("@/../static/img/leamh_icon.png"),
    };
  },
  created() {
    document.title = "Léamh (Beta)";
    var self = this;
    this.cordova.on("deviceready", () => {
      self.onDeviceReady();
    });

    var user = auth.currentUser;
    auth.onAuthStateChanged(
      (user) => {
        if (user) {
          store.dispatch("lookupUser", user);
          store.dispatch("getQuestions");
        } else if (this.currentRoutePublic) {
          store.dispatch("getPaleoData");
        } else {
          this.$router.push("/Login");
        }
      },
      function (error) {
        console.log(error);
      }
    );
  },
  methods: {
    onDeviceReady: function () {
      // Handle the device ready event.
      this.cordova.on("pause", this.onPause, false);
      this.cordova.on("resume", this.onResume, false);
      if (this.cordova.device.platform === "Android") {
        document.addEventListener("backbutton", this.onBackKeyDown, false);
      }
    },
    toggle_check(j) {
      this.items.map(i => i.check = false)
      this.items[j].check = true;
    },
    toggleDrawer() {
      console.log("toggle drawer");
      this.mobileDrawer = !this.mobileDrawer;
    },
    signOut: function () {
      auth.signOut();
      this.$store.commit("setUser", null);
      this.$router.push("/Login");
    },
    onPause() {
      // Handle the pause lifecycle event.
      console.log("pause");
    },
    onResume() {
      // Handle the resume lifecycle event.
      // SetTimeout required for iOS.
      setTimeout(function () {
        console.log("resume");
      }, 0);
    },
    onBackKeyDown() {
      // Handle the back-button event on Android. By default it will exit the app.
      navigator.app.exitApp();
    },
  },
  computed: {
    drawer() {
      return (
        this.$vuetify.breakpoint.name == "xl" ||
        this.$vuetify.breakpoint.name == "lg" ||
        this.mobileDrawer
      );
    },
    loggedInUser() {
      return this.$store.state.user;
    },
    on_quiz() {
      return this.$router.currentRoute.path != "/Quiz";
    },
    currentRoutePublic() {
      return this.$router.currentRoute.path.toLowerCase().includes("public");
    },
    // ...mapGetters(["user"])
  },
};
</script>

<style>
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: semplicitapro, sans-serif;
  font-weight: 700;
  font-style: normal;
}
p, button, span[style], .v-card__text{
   font-family: proxima-nova, sans-serif !important;
  font-weight: 400;
  font-style: normal;
  text-transform: none;
  /* font-size: 16pt; */
}
v-btn, button{
  text-transform: none;
}
h1,h2,h3,h4,h5,h6{
  font-family: semplicitapro, sans-serif !important;
  font-style: normal;
}
body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  font-family: proxima-nova, sans-serif !important;
  font-weight: 400;
  font-style: normal;
}
.footer {
  /* Apply this to v-bottom-nav if necessary. */
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}
#leamhIcon {
  width: 100%;
  height: auto;
}
</style>
